import InvestmentCommitment from './InvestmentCommitment'

export default InvestmentCommitment
